import {ContentType} from 'sdk/src/defines';

type Payload = {
  contentType: ContentType,
  sort?: {column: string, direction: string},
};

const initialState = {
  entities: {},
};

const sortReducer = (state = initialState, action: {type: string, payload: Payload}) => {
  switch (action.type) {
    case 'HANDLE_CONTENT_SORT_SELECTED': {
      const {contentType, sort} = action.payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [contentType]: sort
        }
      }
    }
    default:
      return state;
  }
};

export default sortReducer;